// src/app/features/auth/components/change-password-submit-view.tsx
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Button, CircularProgress } from "@mui/material";

interface ChangePasswordSubmitViewProps {
  isLoading: boolean;
}

const ChangePasswordSubmitView: React.FC<ChangePasswordSubmitViewProps> = ({
  isLoading,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
      <Button
        type="submit"
      variant="contained"
      color="primary"
      fullWidth
        disabled={isLoading}
      sx={{
        py: 1.5,
        fontWeight: 700,
        fontSize: { xs: "1rem", sm: "1.1rem" },
        borderRadius: 2,
        boxShadow: 2,
        textTransform: "none",
      }}
      >
        {isLoading ? (
          <>
            {t("status.changingPassword")}
          <CircularProgress size={22} sx={{ color: "white", ml: 2 }} />
          </>
        ) : (
          t("authentication.changePassword.title")
        )}
      </Button>
  );
};

export default ChangePasswordSubmitView;
